import {IColorPalette} from "@buildwitt/shapeshift-types/IBrand";
import {PlayerConfig, PlayerType, StreamType} from "bitmovin-player/modules/bitmovinplayer-core";

export const sideMenuWidth = "420px";
export const toolbarHeight = "64px";
export const footerHeight = "50px";
export const footerToolbarCombinedHeight = "120px";
export const mobileNavBarHeight = "80px";
export const bannerHeight = "450px";

export const cohortBaseUrl = "/api/strapi-plugin-shapeshift-lms/cohort";

export const palette = {
	background: "#222222",
	darkGrey: "#191919", //> navbar
	midGrey: "rgba(255, 255, 255, 0.6)",
	drawer: "#2c2c2c",
	grey05: "rgba(255, 255, 255, .05)",
	grey08: "rgba(255, 255, 255, .08)",
	grey10: "rgba(255, 255, 255, .1)",
	grey15: "rgba(255, 255, 255, .15)",
	grey20: "rgba(255, 255, 255, .2)",
	grey40: "rgba(255, 255, 255, .4)",
	grey60: "rgba(255, 255, 255, .6)",
	grey70: "rgba(255, 255, 255, .7)",
	grey80: "rgba(255, 255, 255, .8)",
	grey90: "#121212",
	success: "#4CB05C",
	successChip: "#66BB6A",
	greySolid: "#3E3E3E",
	greyDark: "#1E1E1E",
	//primary
	orange: "#FF9E00",
	orange08: "#FF9E0014",
	orange25: "#FF9E0025",
	orange50: "#FF9E0050",
	orange75: "#FF9E0075",
	black: "#191919",
	// grey15: "#989898",
	// midGrey :"#7b7b7b", //#fff 40%
	midGrey2: "#a7a7a7", //#fff 60%
	midGrey3: "#3b3b3b", //#fff 15%
	midGrey4: "#656565",
	greyBorder: "#616161",
	// darkGrey: "#3d3d3d", //#fff 10%  - another vaiant in designs -2c2c2c, 2b2b2b
	error: "#D94949",
	errorLight: "#E57373",
	errorDark: "#F44336",
	successLight: "#81C784",
	successDark: "#388E3C",
	successConstrast: "#0C1F0D",
	warning: "#FFBE54",
	white: "#fff",
	RxdBackground: "#0b0b0b",
	RxdDescription: "#F9F9F9B2",
	RxdProgressTrack: "#FF9E004D",
	RxdBreadcrumbText: "#FFFFFFB2",
	RxdButtonDisabledBg: "#FFFFFF1F",
	RxdButtonDisabledText: "#FFFFFF61"

	//OLD
	// orange: "#FF9E00",
	// orange50: "#FF9E0050",
	// black: "#191919",
	// grey15: "#989898",
	// grey: "#757575",
	// midGrey :"#7b7b7b", //#fff 40%
	// midGrey2: "#a7a7a7", //#fff 60%
	// midGrey3: "#3b3b3b", //#fff 15%
	// midGrey4: "#656565",
	// darkGrey: "#3d3d3d", //#fff 10%  - another vaiant in designs -2c2c2c, 2b2b2b
	// background: "#282828",
	// drawer: "#3E3E3E",
	// error: "#FE4A49",
	// success: "#228B22",
	// white: "#fff"
}

export const templatePalette: IColorPalette = {
	grey: {
		50: "rgba(255, 255, 255, .05)",
		100: "rgba(255, 255, 255, .1)",
		200: palette.grey15,
		300: "rgba(255, 255, 255, .3)",
		400: "rgba(255, 255, 255, .4)",
		600: "rgba(255, 255, 255, .6)",
		700: "rgba(255, 255, 255, .7)",
		800: "rgba(255, 255, 255, .8)",
		900: palette.midGrey
	},
	background: {
		default: palette.background,
		dark: palette.darkGrey,
		paper: palette.greySolid
	},
	primary: {
		main: palette.orange,
		light: palette.orange50,
		dark: palette.orange
	},
	secondary: {
		main: palette.orange,
		light: palette.orange,
		dark: palette.orange
	},
	text: {
		primary: palette.white,
		secondary: palette.grey15,
		light: palette.white,
		disabled: palette.midGrey,
		gray: palette.darkGrey
	},
	success: {
		light: palette.success,
		main: palette.success,
		dark: palette.success
	},
	error: {
		light: palette.error,
		main: palette.error,
		dark: palette.error
	}
}

if(!process.env.REACT_APP_BITMOVIN_PLAYER_KEY)
	throw new Error("REACT_APP_BITMOVIN_PLAYER_KEY required")

export const bitmovinPlayerConfig: PlayerConfig = {
	key: process.env.REACT_APP_BITMOVIN_PLAYER_KEY,
	analytics: {
		key: process.env.REACT_APP_BITMOVIN_ANALYTICS_KEY
	},
	playback: {
		seeking: true,
		preferredTech: [{player: PlayerType.Html5, streaming: StreamType.Hls}]
	},
	adaptation: {
		maxStartupBitrate: 4000000,
		startupBitrate: 3000000,
		bitrates: {
			maxSelectableVideoBitrate: 4000000
		}
	}
};

export const brightcovePlayerConfig = {
	accountId: process.env.REACT_APP_BRIGHTCOVE_ACCOUNT_ID ?? null,
	usePip: false,
	playsinline: true,
	playbackRates: [1, 1.5]
}

export const customerSupportLink = "https://buildwitt.com/customer-support";
export const suggestFeatureLink = "https://portal.productboard.com/buildwitt/1-buildwitt-portal/tabs/3-recently-released/submit-idea";

export const contentTypes: string[] = [
	"Job Training",
	"Personal Development",
	"Professional Development",
	"Safety"
];

export const workCategories = [
	"Asphalt",
	"Blasting and Drilling",
	"Carpentry",
	"Demolition",
	"Drilling and Pile Driving",
	"Earthmoving",
	"Electrical Utilities",
	"Fine Grading",
	"Gas Utilities",
	"Landscaping",
	"Masonry",
	"Mining Operation",
	"Sanitary Sewer",
	"Site Concrete",
	"Storm Sewer",
	"Structural Concrete",
	"SWPP",
	"Telecommunication Utilities",
	"Trenching and Excavation",
	"Trucking",
	"Waterline",
	"Waterproofing"
];

export const jobCategories = [
	"Equipment Maintenance",
	"Equipment Operator",
	"Estimating Sales",
	"Human Resources",
	"Management",
	"Project Administration",
	"Project Management",
	"Project Supervision",
	"Safety Professional",
	"Skilled Labor",
	"Support",
	"Survey Construction Tech"
];

export const EnglishAlphabetAndNumberRegex = /[^A-Za-z0-9]/g;
export const onlyNumbers = /[^0-9]/g;
export const AlphanumericAmpHyphenApostropheParenthesesColonRegex =
	/[^ A-Za-zÁ-ú0-9-'&():]/g;

export const maxSizeImageFile = 3 * 1024 * 1024;
export const imageValidTypes = [
	"image/png",
	"image/jpeg",
	"image/gif",
	"image/svg+xml"
];